@if (!formSent()) {
    @if (loading()) {
        <div class="flex min-h-[450px] items-center justify-center">
            <ui-m000-c040-loading-spinner />
        </div>
    } @else {
        <form
            class="px mx-auto flex max-w-[792px] flex-col gap-24 px-24 pb-40 pt-32"
            [formGroup]="form"
            (ngSubmit)="submitForm()"
        >
            <h3 class="text-24 leading-[29px] lg:text-34 lg:leading-41">Wir sind für Sie da</h3>
            <p class="text-14">Pflichtfelder sind mit * gekennzeichnet</p>
            <div class="flex flex-col justify-between gap-24 lg:flex-row lg:gap-56">
                <div class="w-full lg:max-w-[50%]">
                    <div class="flex h-full flex-col gap-16">
                        @let dealerCtr = form.controls.dealer;
                        @if (hasSubdealers()) {
                            <ui-input-select
                                [formControl]="dealerCtr"
                                [options]="dealerOptions()"
                                [error]="form.controls.dealer.touched && form.controls.dealer.invalid"
                                [errorMsg]="getErrorMessage(dealerCtr)"
                                label="Händler *"
                            />
                        }
                        @let topicCtr = form.controls.topic;
                        <ui-input-select
                            [formControl]="topicCtr"
                            [options]="options"
                            [error]="form.controls.topic.touched && form.controls.topic.invalid"
                            [errorMsg]="getErrorMessage(topicCtr)"
                            label="Thema *"
                        />
                        <ui-input-textarea
                            class="lg:h-full"
                            [formControl]="form.controls.message"
                            [error]="form.controls.message.touched && form.controls.message.invalid"
                            [errorMsg]="getErrorMessage(form.controls.message)"
                            [label]="'Ihre Nachricht'"
                            placeholder=""
                        />
                    </div>
                </div>
                <div class="w-full">
                    <h3 class="mb-24 text-20 leading-25">Ihre Kontaktdaten</h3>
                    <div class="my-12">
                        <ui-input-radio
                            [formControl]="form.controls.gender"
                            [options]="[
                                { label: 'Frau', value: GENDER.FEMALE },
                                { label: 'Herr', value: GENDER.MALE },
                                { label: 'Divers', value: GENDER.DIVERS },
                            ]"
                        />
                    </div>
                    <div class="flex flex-col gap-16">
                        @let firstNameCtr = form.controls.firstName;
                        <ui-input-text
                            [formControl]="firstNameCtr"
                            [error]="firstNameCtr.touched && firstNameCtr.invalid"
                            [errorMsg]="getErrorMessage(firstNameCtr)"
                            label="Vorname *"
                        />
                        @let lastNameCtr = form.controls.lastName;
                        <ui-input-text
                            [formControl]="lastNameCtr"
                            [error]="lastNameCtr.touched && lastNameCtr.invalid"
                            [errorMsg]="getErrorMessage(lastNameCtr)"
                            label="Nachname *"
                        />
                        @let emailCtr = form.controls.email;
                        <ui-input-text
                            [formControl]="emailCtr"
                            [error]="emailCtr.touched && emailCtr.invalid"
                            [errorMsg]="getErrorMessage(emailCtr)"
                            label="E-Mail-Adresse *"
                        />
                        @let phoneCtr = form.controls.phone;
                        <ui-input-text
                            [formControl]="phoneCtr"
                            [error]="phoneCtr.touched && phoneCtr.invalid"
                            [errorMsg]="getErrorMessage(phoneCtr)"
                            label="Telefonnummer *"
                        />
                    </div>
                </div>
            </div>
            <div
                class="frc-captcha"
                #frccaptcha
                data-sitekey="FCMGC0V4K1N4MFFN"
                data-puzzle-endpoint="https://api.friendlycaptcha.com/api/v1/puzzle"
            ></div>
            <div class="flex flex-col items-end gap-24">
                <div class="border-grey-300 text-14 lg:border-t lg:pt-24">
                    <p>
                        {{ disclaimer }}
                        <a [hyundaiRouterLink]="dealer().pages.privacy" target="_blank">
                            https://hyundai-partners{{ dealer().pages.privacy }}
                        </a>
                    </p>
                </div>
                <button class="button-primary lg:max-w-[292px]" [disabled]="form.invalid" type="submit">
                    Absenden
                </button>
            </div>
        </form>
    }
} @else {
    <div class="flex flex-col md:grid md:grid-cols-2 xl:flex xl:flex-row xl:items-center">
        <ui-m000-c010-image
            class="lg:w-500 block h-full"
            [classList]="'h-full aspect-[7/5] object-cover'"
            [image]="heroImage()"
            priority
            alt="Service Anfrage - Bildbeispiel"
            cover
            highRes
        />
        <div
            class="flex flex-col items-start justify-center p-24 text-black md:p-56 lg:min-w-[540px] xl:w-1/2 xl:pr-[112px]"
        >
            <h1 class="text-31 leading-36 md:text-34 md:leading-41">
                Ihre Anfrage wurde
                <br class="hidden md:block" />
                erfolgreich versendet.
            </h1>

            <div class="w-full whitespace-pre-line">
                <div class="mb-[20px] mt-16 text-16 leading-27">
                    <p>
                        Vielen Dank, wir haben Ihre Anfrage erhalten.
                        <br />
                        Wir werden Sie schnellstmöglich kontaktieren.
                        <br />
                        <br />
                        Ihr {{ selectedDealerName() || dealerName() }} Team
                    </p>
                </div>

                <a class="button-primary md:w-auto" [hyundaiRouterLink]="'/' + dealer().slug">Zur Startseite</a>
            </div>
        </div>
    </div>
}
